import io from "socket.io-client";
import { socketServerHost } from "./config";

const URL = socketServerHost;

export const socket = io(URL, {
  autoConnect: false,
  query: { id: "" },
  transports: ["websocket"],
});
